import { FormattedMessage } from 'react-intl'

import { useAsyncInterval } from '@subaio/components'

import type { Step, StepType } from 'containers/Flow/Step'

import { LinkSolidNative } from 'components/Buttons'
import { IconHeaderCoin } from 'components/Icons'
import { Card } from 'components/Layout'
import { Spinner } from 'components/Spinner'

import { Content } from './Content'
import { HeaderIconWrapper } from './HeaderIconWrapper'
import { Wrapper } from './Wrapper'

type Props = TaggedType<Step, StepType.Redirect>

export const Redirect = ({ redirectUrl }: Props) => {
	useAsyncInterval(2, () => {
		document.location.replace(redirectUrl)
	})

	return (
		<Wrapper>
			<Card>
				<IconHeaderCoin />
				<Content>
					<h2>
						<FormattedMessage id='flow.redirect.title' defaultMessage='Your data has been submitted' />
					</h2>
					<HeaderIconWrapper>
						<h3>
							<FormattedMessage
								id='flow.redirect.loading'
								defaultMessage='You will be redirected shortly - please wait...'
							/>
						</h3>
						<Spinner />
						<p>
							<FormattedMessage
								id='flow.redirect.description'
								defaultMessage='If the page does not redirect automatically, please click the button below to continue.'
							/>
						</p>
						<LinkSolidNative
							href={redirectUrl}
							label={<FormattedMessage id='flow.redirect.buttonContinue' defaultMessage='Continue' />}
							rel='noopener noreferrer'
						/>
					</HeaderIconWrapper>
				</Content>
			</Card>
		</Wrapper>
	)
}
